import React, { Component } from 'react';
import './AuthWrapper.css';
import { Button } from 'react-bootstrap';

class AuthWrapper extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    window.$zopim &&
      window.$zopim.livechat &&
      window.$zopim.livechat.window.show();
  }

  render() {
    const { children } = this.props;

    return (
      <div className="auth-wrapper">
        <div className="auth">{children}</div>
        <Button
          className="btn login-chat-btn btn-success btn-square"
          onClick={this.handleClick}
        >
          Support
        </Button>
      </div>
    );
  }
}

export default AuthWrapper;



// WEBPACK FOOTER //
// ./src/components/AuthWrapper/index.js